/**
 * Der Stundensatz (pro 60 Minuten) aus dem Honorar je Termin.
 *
 * Im Auftrag stand bisher nur „Verhandeltes Honorar (pro Termin)“; es heißt jetzt
 * „Stundensatz“ (T-0282) und meint den Satz pro 60 Minuten — gerechnet wie im
 * Backend (`public_flow_service`), damit Office und Website dasselbe zeigen.
 */
export function stundensatzAus(
  honorarJeTerminCents: number | null | undefined,
  dauerMinuten: number | null | undefined,
): number | null {
  if (typeof honorarJeTerminCents !== 'number' || honorarJeTerminCents <= 0) return null;
  if (typeof dauerMinuten !== 'number' || dauerMinuten <= 0) return null;
  return Math.round((honorarJeTerminCents * 60) / dauerMinuten);
}
